import * as React from 'react'
import Drawer from '@mui/material/Drawer'
import { SideDrawerProps, getDrawerStyles } from '@sales-center/components'
import Typography from '@mui/material/Typography/Typography'

export const SideDrawer: React.FC<SideDrawerProps> = (
  props: SideDrawerProps,
) => {
  const { open, title, onClose, children, disableBackdropClick } = props

  const handleOnClose = React.useCallback(
    (_, reason: 'backdropClick' | 'escapeKeyDown') => {
      if (disableBackdropClick && reason === 'backdropClick') return
      onClose()
    },
    [disableBackdropClick, onClose],
  )
  const styles = getDrawerStyles(props)
  return (
    <Drawer
      open={open}
      onClose={handleOnClose}
      variant="temporary"
      anchor="right"
      PaperProps={{ sx: styles.drawer }}
      ModalProps={{ sx: styles.modal }}
    >
      {title && (
        <Typography
          display={'flex'}
          padding={2}
          sx={{ alignItems: 'center' }}
          variant="h5"
          id="sliderHeading"
        >
          {title}
        </Typography>
      )}
      {children}
    </Drawer>
  )
}
